import React from 'react';
import { BoxProps, MotionBox } from '@tapresearch/ui/components';
export interface OpacityTransitionBoxProps
  extends Omit<BoxProps, 'transition'> {
  finalOpacity?: number;
  duration?: number;
}

export function OpacityTransitionBox({
  finalOpacity = 1,
  duration = 1,
  ...rest
}: OpacityTransitionBoxProps) {
  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: finalOpacity }}
      transition={{
        opacity: { type: 'tween', default: { duration } },
      }}
      exit={{ opacity: 0 }}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(rest as any)}
    />
  );
}
